import { render } from "./PracticePage.vue?vue&type=template&id=360e563d"
import script from "./PracticePage.vue?vue&type=script&lang=js"
export * from "./PracticePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__